export default __webpack_public_path__ + "static/media/appStore-en.610ddb06.svg";